<template>
  <div>
    <vue-friendly-iframe :src="src"></vue-friendly-iframe>
  </div>
</template>

<style scoped>

.text-editor {
  border-radius: 15px;
  font-size: 18px;
  width: 100%;
}

.submit-btn {
  margin-left: 50px;
  font-size: 22px;
  font-weight: 600;
  text-decoration: none;
  margin-top: 40px;
  padding: 9px 21px;
  background: #fff;
  color: #c0b8ad;
  border: 2px solid #a69f95;
  border-radius: 4px;
}

.submit-btn:hover {
  color: #7d6038;
  border: 2px solid #6c5330;
}

.submit-btn:active {
  color: #908b85;
  border: 2px solid #7d7973;
}
</style>

<script>


export default {
  props: ["task", "resolveExercise"],
  data() {
    return {
      src: "https://exallenge-editor.web.app/?course=t1&task=" + (this.task.meta.taskNum-1),
      userRunCode: true,
      terminalValue: "",
      code: "",
      serverInput: [],
      serverOutput: [],
      userOutput: [],
      finishedWithError: false,
      cmOptions: {
        tabSize: 4,
        mode: "text/x-python",
        theme: "base16-light",
        lineNumbers: true,
        line: true
        // more CodeMirror options...
      }
    };
  },
  created: async function() {
    console.log(this.task.meta.taskNum); // eslint-disable-line no-console

  }
};
</script>